import type { Classroom } from '../classroom';
import type { ClassroomTeacher } from '../teacher/teacher';

type TeacherEnrollment = {
  id: string;
  name: string;
};

type ClassroomTeacherEnrollment = {
  id: string;
  source: {
    id: string;
    name: string;
  } | null;
  teacher: {
    id: string;
    name: string;
  };
};

function isTeacherEnrolledInClassroomManually(
  classroom: Classroom,
  teacherId: string
): boolean {
  return !classroom.teacherEnrollments?.find(
    (enrollment) => enrollment.teacher.id === teacherId
  )?.source?.id;
}

function isClassroomTeacherEnrolledManually(
  teacher: ClassroomTeacher
): boolean {
  return !teacher.classroomEnrollment?.id;
}

export {
  isClassroomTeacherEnrolledManually,
  isTeacherEnrolledInClassroomManually,
};

export type { ClassroomTeacherEnrollment, TeacherEnrollment };
